import script from "./AdStatCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AdStatCard.vue?vue&type=script&setup=true&lang=js"

import "./AdStatCard.vue?vue&type=style&index=0&id=3627d50d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3627d50d"]])

export default __exports__